import React from 'react';
import { ButtonStyled } from '../../../../../containers/MerchandisingRules/CreateMerchandisingRuleContainer/CreateMerchandisingRuleContainer.styles';
import { RuleFormFooter } from '../../../../MerchandisingRules/components/MerchandisingRuleForm/RuleFormFooter';

interface Props {
  canSubmit: boolean;
  onSaveChanges: VoidFunction;
  onCancel: VoidFunction;
  onCreate: VoidFunction;
  isCreateMode?: boolean;
  className?: string;
  isReadOnly?: boolean;
}

export const EditCollectionRulesFooter = ({
  isCreateMode,
  onCancel,
  canSubmit,
  onSaveChanges,
  onCreate,
  className,
  isReadOnly = false,
}: Props): JSX.Element => {
  return (
    <RuleFormFooter className={className}>
      <ButtonStyled variant='tertiary' onClick={onCancel} disabled={isReadOnly}>
        Cancel
      </ButtonStyled>
      {isCreateMode ? (
        <ButtonStyled disabled={!canSubmit || isReadOnly} variant='primary' onClick={onCreate}>
          Create
        </ButtonStyled>
      ) : (
        <ButtonStyled disabled={!canSubmit || isReadOnly} variant='primary' onClick={onSaveChanges}>
          Save
        </ButtonStyled>
      )}
    </RuleFormFooter>
  );
};
